import { NgModule } from '@angular/core';
import { SlideOutPanelComponent } from './slide-out-panel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SlideOutPanelService } from './slide-out-panel.service';
import { CommonModule } from '@angular/common';
import { SlideOutPanelHeaderComponent } from './slide-out-panel-header/slide-out-panel-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { SidePanelStateService } from './side-panel-state.service';

@NgModule({
  declarations: [SlideOutPanelComponent, SlideOutPanelHeaderComponent],
  exports: [SlideOutPanelComponent, SlideOutPanelHeaderComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatToolbarModule,
    GalaxyBadgeModule,
  ],
  providers: [SlideOutPanelService, SidePanelStateService],
})
export class SlideOutPanelModule {}
